import PropTypes from 'prop-types';
import validator from 'lib/validator';

import { FormManager, Form, GeneralError } from 'lib/form';
import { Link, Button } from 'components/common';
import { TextField, PasswordField } from 'components/formFields';

import useAuth from './useAuth';
import { useState } from 'react';

const validationSchema = validator.object({
  email: validator.string().email().required(),
  password: validator.string().required(),
});

const LoginForm = ({ redirect }) => {
  const { signIn } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleOnSubmit = async (
    { email, password, rememberMe },
    actions,
  ) => {
    setIsLoading(true);
    actions.setStatus({ error: null }); // clear general error

    const { error } = await signIn({
      redirect,
      email,
      password,
      rememberMe,
    });

    if (error) {
      actions.setStatus({ error });
      setIsLoading(false);
    }
  };

  return (
    <FormManager
      initialValues={{
        email: '',
        password: '',
        rememberMe: true,
      }}
      onSubmit={handleOnSubmit}
      validationSchema={validationSchema}
    >
      {({ isSubmitting }) => (
        <Form>
          <GeneralError />

          <TextField name="email" label="Email address" required />

          <PasswordField name="password" label="Password" required />

          <div
            className="form-footer"
            style={{
              borderBottom: 'unset',
              marginBottom: 'unset',
              paddingBottom: 'unset',
            }}
          >
            <Button
              type="submit"
              variant="outlined"
              loading={isLoading}
            >
              <span>LOG IN</span>
              <i className="icon-long-arrow-right"></i>
            </Button>

            <Link to="/auth/forgotPassword" className="forgot-link">
              Forgot Your Password?
            </Link>
          </div>
        </Form>
      )}
    </FormManager>
  );
};

LoginForm.propTypes = {
  redirect: PropTypes.bool,
};

LoginForm.defaultProps = {
  redirect: true,
};

export default LoginForm;
